// 2026-10-06 (control-plane change support-requests): "Contact support" from Studio and the support queue in Admin —
// typed by hand from control-plane/api/openapi.yaml (tag support, admin /v1/admin/support/requests…) until the next
// pin bump brings the generated types.

interface Problem { type: string; title: string; status: number; detail?: string; request_id?: string; errors?: { field: string; detail: string }[] }
type Json<T> = { content: { 'application/json': T } };
type Ok<T> = { 200: Json<T> };
type Created<T> = { 201: Json<T> };
type Err = { 400: Json<Problem>; 401: Json<Problem>; 403: Json<Problem>; 404: Json<Problem>; 422: Json<Problem>; 429: Json<Problem> };
type PathId = { path: { id: string } };

export type SupportCategory = 'question' | 'bug' | 'outage' | 'billing' | 'feature_request' | 'other';
export type SupportPriority = 'normal' | 'high' | 'urgent';
export type SupportStatus = 'open' | 'in_progress' | 'waiting_customer' | 'resolved' | 'closed';
export type SupportLang = 'he' | 'en';

export const SUPPORT_CATEGORIES: SupportCategory[] = ['question', 'bug', 'outage', 'billing', 'feature_request', 'other'];
export const SUPPORT_PRIORITIES: SupportPriority[] = ['normal', 'high', 'urgent'];
export const SUPPORT_STATUSES: SupportStatus[] = ['open', 'in_progress', 'waiting_customer', 'resolved', 'closed'];

/** One API error Studio saw recently (attached to a request; no tokens, cookies or query strings). */
export interface SupportContextError { at?: string; method?: string; path?: string; status?: number; type?: string; message?: string; request_id?: string }
/** What Studio attaches to a request automatically. Every field optional; the server bounds and redacts them. */
export interface SupportContext {
  page_path?: string; studio_version?: string; user_agent?: string; time_zone?: string; locale?: string;
  request_ids?: string[]; errors?: SupportContextError[]; channel_id?: string; asset_id?: string;
}
export interface SupportRequest {
  id: string; tenant_id: string; tenant_slug: string; tenant_name: string;
  created_by_user: string | null; created_by_key: string | null; created_by: string;
  contact_email: string; contact_name: string; lang: SupportLang;
  category: SupportCategory; priority: SupportPriority; subject: string; message: string; context: SupportContext;
  status: SupportStatus; assignee: string | null; created_at: string; updated_at: string; last_reply_at: string | null; message_count: number;
}
export interface SupportMessage { id: string; request_id: string; author_kind: 'customer' | 'interhost'; author_email: string; author_name: string; body: string; created_at: string }
export interface SupportRequestDetail extends SupportRequest { messages: SupportMessage[] }
export interface SupportRequestPage { items: SupportRequest[]; next_cursor: string | null; counts: Partial<Record<SupportStatus, number>> }
export interface SupportRequestInput {
  category: SupportCategory; priority?: SupportPriority; subject: string; message: string;
  contact_email?: string; contact_name?: string; lang?: SupportLang; context?: SupportContext;
}
type SupportQuery = { status?: SupportStatus; category?: SupportCategory; priority?: SupportPriority; cursor?: string; limit?: number };

export interface SupportPaths {
  '/v1/support/requests': {
    get: { parameters: { query?: SupportQuery }; responses: Ok<SupportRequestPage> & Err };
    post: { requestBody: Json<SupportRequestInput>; responses: Created<SupportRequestDetail> & Err };
  };
  '/v1/support/requests/{id}': { get: { parameters: PathId; responses: Ok<SupportRequestDetail> & Err } };
  '/v1/support/requests/{id}/messages': { post: { parameters: PathId; requestBody: Json<{ body: string }>; responses: Created<SupportRequestDetail> & Err } };
  '/v1/support/requests/{id}/close': { post: { parameters: PathId; responses: Ok<SupportRequestDetail> & Err } };
  '/v1/admin/support/requests': { get: { parameters: { query?: SupportQuery & { tenant?: string } }; responses: Ok<SupportRequestPage> & Err } };
  '/v1/admin/support/requests/{id}': {
    get: { parameters: PathId; responses: Ok<SupportRequestDetail> & Err };
    patch: { parameters: PathId; requestBody: Json<{ status?: SupportStatus; assignee?: string }>; responses: Ok<SupportRequestDetail> & Err };
  };
  '/v1/admin/support/requests/{id}/messages': { post: { parameters: PathId; requestBody: Json<{ body: string; status?: SupportStatus }>; responses: Created<SupportRequestDetail> & Err } };
}
